// The Playground's pseudo-client: the sphinx server itself chatting with the
// model and calling tools over the inspector's own MCP connection (today's
// direct mode). A client-only constant — NOT a TargetId, never in the
// `targets` table; the real ten clients dispatch through the queue instead.
import { TARGET_IDS, type TargetId } from "@/shared/sphinx";

export const DIRECT_CLIENT_ID = "direct";
export const DIRECT_CLIENT_NAME = "Direct (sphinx server)";

export const isDirectClientId = (id: string | null | undefined): boolean =>
  id === DIRECT_CLIENT_ID;

export const isRealTargetId = (id: string): id is TargetId =>
  (TARGET_IDS as readonly string[]).includes(id);

/** The lineup's real clients, in lineup order. */
export const realTargetsInLineup = (lineup: readonly string[]): TargetId[] =>
  lineup.filter(isRealTargetId);
